import { render, staticRenderFns } from "./TableHandover.vue?vue&type=template&id=61bc2d5a&"
import script from "./TableHandover.vue?vue&type=script&lang=js&"
export * from "./TableHandover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports